document.addEventListener('DOMContentLoaded', function() {
    if (NewBadges) {
        // console.log("badge-extender found NewBadges!");
        const originalSet = NewBadges.set; 
        NewBadges.set = function(product, productElement) {
            originalSet.call(this, product, productElement);

            if (product.tags.includes("go_product")) {
                clearBadges(productElement);

                this.addLabel(productElement, `<span class="go-product-badge" style="position: absolute;
                top: 0;
                z-index: 1;
                padding-top: 10px;
                padding-left: 10px;">
                    <svg width="72" height="27" viewBox="0 0 72 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#a)">
                            <path d="M63.954 13.445q0 3.859-1.794 6.948-1.793 3.09-4.854 4.813-3.063 1.724-6.761 1.723-3.698.001-6.78-1.723-3.081-1.723-4.892-4.813-1.813-3.09-1.812-6.948 0-3.857 1.812-6.928 1.81-3.071 4.893-4.794Q46.846 0 50.545 0t6.779 1.723a12.63 12.63 0 0 1 4.856 4.794q1.773 3.072 1.774 6.928" fill="#26585F"/>
                            <path d="M34.196 11.865v6l-.007.02v8.926h-4.793v-2.26q-.912.647-1.975 1.166Q24.786 27 21.474 27q-3.915 0-6.982-1.718a12.2 12.2 0 0 1-4.78-4.775Q8 17.45 8 13.525t1.712-7.002a12.2 12.2 0 0 1 4.761-4.792Q17.522.013 21.436.013q4.742.001 8 2.302 3.254 2.303 4.308 6.379h-7.113a4.83 4.83 0 0 0-2.052-2.019q-1.335-.699-3.143-.699-3.124 0-5.005 2.058-1.882 2.057-1.882 5.491 0 3.662 1.976 5.719 1.976 2.056 5.438 2.056 2.371.001 4.008-1.207t2.391-3.472h-8.168v-4.756z"/>
                            <path d="M63.954 13.445q0 3.859-1.794 6.948-1.793 3.09-4.854 4.813-3.063 1.724-6.761 1.723-3.698.001-6.78-1.723-3.081-1.723-4.892-4.813-1.813-3.09-1.812-6.948 0-3.857 1.812-6.928 1.81-3.071 4.893-4.794Q46.846 0 50.545 0t6.779 1.723a12.63 12.63 0 0 1 4.856 4.794q1.773 3.072 1.774 6.928m-29.758-1.58v6.001l-.007.02v8.925h-4.793v-2.26q-.912.647-1.975 1.166Q24.786 27 21.474 27q-3.915 0-6.982-1.718a12.2 12.2 0 0 1-4.78-4.774Q8 17.45 8 13.525t1.712-7.001a12.2 12.2 0 0 1 4.761-4.793Q17.522.015 21.436.014q4.742 0 8 2.301 3.254 2.303 4.308 6.379h-7.113a4.83 4.83 0 0 0-2.052-2.018q-1.335-.7-3.143-.7-3.124 0-5.005 2.058-1.882 2.057-1.882 5.491 0 3.662 1.976 5.719t5.438 2.056q2.371.001 4.008-1.207t2.391-3.472h-8.168v-4.756z" fill="#26585F"/>
                        </g>
                        <defs>
                            <clipPath id="a">
                            <path fill="#26585F" d="M0 0h72v27H0z"/>
                            </clipPath>
                        </defs>
                    </svg>
                    </span>`);
            }
        };
    }
});

function clearBadges(productElement) {
    const badgesWrapper = productElement.querySelector('.fs-badges-wrapper');
    if (badgesWrapper) {
        badgesWrapper.innerHTML = ''; 
    }
}

